<template>
  <div class="layout-center-wrap">
    <Auth v-on:success="nonMemberlogin" type="NONMEMBER" />
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { inject, onMounted } from "vue";
import { useStore } from "vuex";
import Auth from "./Auth.vue";
import dc from "@/component/DataChk.js";

export default {
  components: {
    Auth,
  },
  setup() {
    const axios = inject("axios");
    const router = useRouter();
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    // methods 정의
    const nonMemberlogin = (refId) => {
      if (!dc.nullChk(refId)) {
        alert("잘못된 접근입니다.\n초기 페이지로 이동합니다.");
        router.push("/");
        return;
      }

      showLoading();
      axios
        .post("/core/pu/member/non/login", {
          id: refId,
          guestType: "domestic",
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            router.push({ name: "reportCommonUser" });
          } else {
            axios.setErrorSession(1003, res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    // life cycle 정의
    onMounted(() => {});

    // html에서 사용될 데이터 정의
    return {
      nonMemberlogin,
    };
  },
};
</script>
<style>
</style>